import React from 'react';
import { useSelector } from 'react-redux';

import { getPxElementConfig, getSectionNameConfig } from '../../../../store/selectors/session';
import BottomActionStrip from './padV2/BottomActionStrip';
import { IGNORE_CONFIG_KEYS } from '../../../../constants';
import DynamicSectionCard from './padV2/DynamicSectionCard';
import { PAD_V2_CONTAINER } from './PadContainer';
import { CareCanvasUpdateComponent, PAD_COMPONENTS } from './PadComponents';
import { getSectionNameFromKey } from '../../../../pages/utils';
import AdmissionToIPD from './AdmissionToIPD';

const PPPadElements: React.FC = () => {
    const padElementsConfig = useSelector(getPxElementConfig);
    const sectionNameConfig = useSelector(getSectionNameConfig);
    const isFollowupAndAdvicesEnabled = padElementsConfig.find((i) => i.id === 'followup-advices')
        ?.isShown;

    return (
        <div className="col-span-11 overflow-hidden h-full flex flex-col">
            <div
                id={PAD_V2_CONTAINER}
                className="px-16 py-16 space-y-8 overflow-auto h-full row-container relative padV2-panel z-0"
            >
                <CareCanvasUpdateComponent />
                {padElementsConfig
                    ?.filter((t) => t.isShown)

                    .filter((i) => !IGNORE_CONFIG_KEYS.has(i.id))
                    ?.map((item) => {
                        if (item.id === 'followup-advices') {
                            return (
                                PAD_COMPONENTS[item.id]?.(
                                    getSectionNameFromKey('followup', sectionNameConfig),
                                    getSectionNameFromKey('advices', sectionNameConfig),
                                ) || <DynamicSectionCard id={item.id} name={item.name} />
                            );
                        }

                        return (
                            PAD_COMPONENTS[item.id]?.(
                                getSectionNameFromKey(item?.id, sectionNameConfig),
                            ) || <DynamicSectionCard id={item.id} name={item.name} />
                        );
                    })}
                {!isFollowupAndAdvicesEnabled && <AdmissionToIPD />}
                {PAD_COMPONENTS.dyform()}
                <div style={{ height: 300 }} />
            </div>
            <BottomActionStrip />
        </div>
    );
};

export default PPPadElements;
